import { WrappedGetLoadStateResponse } from '../services/get-tours';
import { TourStore as TourModel } from '../stores/tour';


// возвращает прогресс поиска в процентах
export function calcSearchProgress(state: WrappedGetLoadStateResponse): number {
    const currentCountTO = state.operatorsList.reduce((progress, operator) => {
        return operator.isProcessed ? progress + 1 : progress;
    }, 0);
    return Math.round(currentCountTO / state.operatorsList.length * 100);
}

// создаёт составной ключ, по которому группируются туры
// https://agile.sletat.ru/jiraurl/browse/SLT-2466?focusedCommentId=187733&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-187733
export function createCompositeKeyForTourPack(tour: TourModel): string {
    return tour.operatorName + tour.roomType + tour.mealCode + tour.accommodationCode +
        tour.nights + String(tour.departDate && tour.departDate.getTime());
}
